import { render, staticRenderFns } from "./allproducts.vue?vue&type=template&id=475068fa&scoped=true&"
import script from "./allproducts.vue?vue&type=script&lang=js&"
export * from "./allproducts.vue?vue&type=script&lang=js&"
import style0 from "./allproducts.vue?vue&type=style&index=0&id=475068fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475068fa",
  null
  
)

export default component.exports